// @ts-nocheck
import { makeStyles, createStyles } from "@material-ui/core/styles";

export const useLateralNavStyles = makeStyles((theme) =>
  createStyles({
    sideBar: {
      position: "relative",
      backgroundColor: "#ffffff",
      margin: "3vh 0vh",
      flex: "0 0 270px",
      maxWidth: "270px"
    },
    sideBarContain: {
      height: "94vh",
      position: "relative",
      borderRight: `2px solid #dfdee0`,
    },
    logoDivider: {
      marginTop: "-0.5rem",
      marginBottom: "-0.5rem",
      marginLeft: "1.5rem",
      marginRight: "1.5rem",
    },
    sideBarLinksContainer: {
      overflowY: "scroll",
      maxHeight: "73vh",
      minHeight: "73vh",
      paddingBottom: "2vh",
      "&::-webkit-scrollbar": { display: "none" },
      scrollbarWidth: "none",
    },
    sideStyleBar: {
      width: "100%",
    },
    navRowToggle: {
      justifyContent: "space-between",
      outline: "none",
      "&:focus-visible": {
        outline: `2px solid ${theme.palette.primary.main}`,
      },
    },
    navRowLabel: {
      display: "flex",
      alignItems: "center",
      gap: "0.75rem",
    },
    sideLink: {
      fontFamily: "Nunito Sans",
      fontSize: "18px",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 2,
      letterSpacing: "normal",
      color: theme.palette.text.secondary,
      cursor: "pointer",
      textAlign: "left",
      display: "flex",
      alignItems: "center",
      gap: "0.75rem",
      textDecoration: "none",
      margin: "0.25rem 0.5rem",
      padding: "0.5rem 2rem",
      borderRadius: "4px"
    },
    activeSideLink: {
      color: theme.palette.navHighlight.main,
      backgroundColor: theme.palette.navHighlight.background,
      fontWeight: 600,
    },
    subLink: {
      fontFamily: "Nunito Sans",
      display: "inline-block",
      fontSize: "16px",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      color: theme.palette.text.secondary,
      cursor: "pointer",
      textAlign: "left",
      textDecoration: "none",
      margin: "0.4rem 0rem",
      marginLeft: "3.5rem",
    },
    activeSubLink: {
      fontSize: "16px",
      display: "inline-block",
      color: theme.palette.navHighlight.main,
      textTransform: "none",
      textDecoration: "none",
      cursor: "pointer",
      margin: "0.4rem 0rem",
      fontWeight: "bold",
      marginLeft: "3.5rem",
    },
    drawerPaper: {
      width: "270px",
    },
    closeMenuButton: {
      marginRight: "auto",
      marginLeft: 0,
    },
    trialPeriodBoxContainer: {
      backgroundColor: "#fff",
      padding: "1rem 3rem",
      zIndex: theme.zIndex.appBar + 1,
    },
    trialPeriodBox: {
      backgroundColor: "#f4f4f4",
      borderRadius: "12px",
      padding: "1rem",
    },
    trialTitle: {
      fontFamily: "Nunito Sans",
      fontSize: "1.8rem",
      fontWeight: "bold",
      color: theme.palette.error.main,
      display: "block",
    },
    trialSubtitle: {
      fontFamily: "Nunito Sans",
      fontSize: "1rem",
      color: theme.palette.text.secondary,
    },
  })
);
